import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import './adminAlerts.css';

const swalBase = {
  background: '#121212',
  color: '#ececec',
  confirmButtonColor: '#e8941a',
  cancelButtonColor: '#333',
  buttonsStyling: true,
  customClass: {
    popup: 'admin-swal',
    title: 'admin-swal__title',
    htmlContainer: 'admin-swal__text',
    confirmButton: 'admin-swal__confirm',
    cancelButton: 'admin-swal__cancel',
  },
};

export function showSuccess(message, title = 'Done') {
  return Swal.fire({
    ...swalBase,
    icon: 'success',
    title,
    text: message,
    timer: 2200,
    timerProgressBar: true,
    showConfirmButton: false,
  });
}

export function showError(message, title = 'Something went wrong') {
  return Swal.fire({
    ...swalBase,
    icon: 'error',
    title,
    text: message,
    confirmButtonText: 'OK',
  });
}

export async function confirmDelete({
  title = 'Delete this item?',
  text = 'This cannot be undone.',
}) {
  const result = await Swal.fire({
    ...swalBase,
    icon: 'warning',
    title,
    text,
    showCancelButton: true,
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
    reverseButtons: true,
    focusCancel: true,
  });

  return result.isConfirmed;
}

export async function confirmLogout() {
  const result = await Swal.fire({
    ...swalBase,
    icon: 'question',
    title: 'Log out?',
    text: 'You will need to sign in again.',
    showCancelButton: true,
    confirmButtonText: 'Log out',
    cancelButtonText: 'Stay',
    reverseButtons: true,
    focusCancel: true,
  });

  return result.isConfirmed;
}
